export default "__VITE_ASSET__CEb6pa4X__"